import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { SIGNIN_USER, SIGNOUT_USER } from "../../constants/ActionTypes";
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
} from "../../appRedux/actions/Auth";

import AuthServices from "../../services/auth";
import appState from "../../state/AppStateContainer";

/* ----------------
  SIGN IN USER SAGA
---------------- */
const signInUserAsync = async (email, password) =>
  await AuthServices.signIn(email, password)
    .then((authUser) => authUser)
    .catch((error) => error);

function* signInUser({ payload }) {
  const { email, password } = payload;
  try {
    const signInUser = yield call(signInUserAsync, email, password);

    if (signInUser.error) {
      yield put(showAuthMessage(signInUser.error));
    } else {
      localStorage.setItem("user_id", signInUser.user.id);
      localStorage.setItem("role", signInUser.user.role);
      appState.setToken(signInUser.user.accessToken);
      yield put(userSignInSuccess(signInUser.user.id));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* watchSignInUser() {
  yield takeEvery(SIGNIN_USER, signInUser);
}

function* signOutUser() {
  try {
    localStorage.removeItem("user_id");
    localStorage.removeItem("role");
    appState.logout();
    yield put(userSignOutSuccess(signOutUser));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

export function* watchSignOutUser() {
  yield takeEvery(SIGNOUT_USER, signOutUser);
}

export default function* rootSaga() {
  yield all([fork(watchSignInUser), fork(watchSignOutUser)]);
}
